import { render, staticRenderFns } from "./mBanner.vue?vue&type=template&id=670abf2e&scoped=true"
import script from "./mBanner.vue?vue&type=script&lang=js"
export * from "./mBanner.vue?vue&type=script&lang=js"
import style0 from "./mBanner.vue?vue&type=style&index=0&id=670abf2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670abf2e",
  null
  
)

export default component.exports